// frame: HOWuT @ ui/dogdisk-user.pen
// spec: docs/ui/user-page-flows.md §2.7 HOWuT 页面-代理上下文错误
//
// cookie 缺失 / 不匹配代理 user 的路由前置错误。公开页(无 session)。

import { useNavigate, useSearchParams } from 'react-router-dom'
import { ErrorPageView } from './_view'

export function AgentErrorPage() {
  const navigate = useNavigate()
  const [sp] = useSearchParams()
  const traceId = sp.get('trace_id') ?? sp.get('trace') ?? null
  const code = sp.get('code') ?? 'LOGIN_NOT_FOUND'

  return (
    <ErrorPageView
      frameId="HOWuT"
      code={null}
      title="账号无法登录"
      desc={
        <>
          代理上下文缺失或不匹配。可能是 cookie 已过期、被清理,
          <br />
          或当前域名与原代理域名不一致。
        </>
      }
      reason={traceId ? `${code} · ${traceId}` : code}
      actions={
        <>
          <button
            type="button"
            data-testid="8qCMo"
            onClick={() => navigate('/auth/login')}
            className="h-12 w-full rounded-lg bg-[#19caad] text-[14px] font-semibold text-white active:bg-[#14a18b]"
          >
            重新登录
          </button>
          <button
            type="button"
            data-testid="MIBE6"
            onClick={() => navigate('/tickets/new')}
            className="h-12 w-full rounded-lg bg-[#F6F7F8] text-[14px] font-semibold text-[#1A1A1A]"
          >
            联系客服
          </button>
        </>
      }
    />
  )
}
